import React from 'react';
import { Button, Icon } from '@tencent/spaui';
import { NOT_UPDATE_APP_TIPS } from 'pages/manage/application/constants';

const ToolbarConfig: (props: any) => { left: JSX.Element } = (props: any) => {
  const { showEditDialog, notUpdateApp } = props;
  return {
    left: (
      <div className="toolbar-right-group">
        <Button
          className="tab-button tool"
          onClick={() => showEditDialog()}
          displayType="primary"
          disabled={notUpdateApp}
          tip={notUpdateApp && NOT_UPDATE_APP_TIPS}
        >
          <div className="icon-plus tool">
            <Icon name="plus-outlined" style={{ marginRight: 6 }} />
            添加应用
          </div>
        </Button>
      </div>
    ),
  };
};
export default ToolbarConfig;
